export default {
  gameSummary: {
    sections: {
      matchupInformation: "Matchup-Informationen",
      rankings: "Rankings",
    },
    labels: {
      record: "Bilanz",
      rank: "Rang",
      type: "Typ",
      stat: "Stat",
      filterByGame: "Nach Spiel filtern",
      position: "Position",
      injury: "Verletzung",
      status: "Status",
      trend: "Trend",
    },
    standingTypes: {
      division: "Division",
      conference: "Conference",
      league: "Liga",
      overall: "Gesamt",
    },
    rankingSides: {
      FOR: "FÜR",
      AGAINST: "GEGEN",
    },
    statAbbreviations: {
      PTS: "PUNKTE",
      "SCORE %": "SCORE %",
      "SCORE%": "SCORE%",
      PLAYS: "SPIELZÜGE",
      "NET YDS": "NET YDS",
      "PASS YDS": "PASS YDS",
      "PASS ATT": "PASS-VERS.",
      "PASS COMPL": "PASS-ABSCHL.",
      "PASS TD": "PASS TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH ATT": "RUSH-VERS.",
      "RUSH TD": "RUSH TD",
      "TOTAL TDS": "TOTAL TDS",
      "RZ%": "RZ%",
      "1D": "1D",
      "3D%": "3D%",
      "4D%": "4D%",
      INT: "INT",
      TO: "TO",
      SACKS: "SACKS",
      FUML: "FUML",
      G: "TORE",
      SOG: "SOG",
      SAT: "SAT",
      "CF%": "CF%",
      "PP%": "PP%",
      PIM: "PIM",
      PPG: "PPG",
      SHG: "SHG",
      "SH%": "SH%",
      BLK: "BLK",
      FTM: "FTM",
      FTA: "FTA",
      "FT%": "FT%",
      FGM: "FGM",
      FGA: "FGA",
      "FG%": "FG%",
      "3PTM": "3PTM",
      "3PTA": "3PTA",
      "3PT%": "3PT%",
      "TS%": "TS%",
      "eFG%": "eFG%",
      TRB: "REB",
      AST: "AST",
      STL: "STL",
      R: "RUNS",
      H: "HITS",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "TB",
      ER: "ER",
      HR: "HR",
      RBI: "RBI",
      BB: "BB",
      SO: "SO",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS",
      SHO: "SCHÜSSE",
      SOT: "SOT",
      COR: "ECKEN",
      OFF: "ABSEITS",
      FLS: "FOULS",
      "2YELRED": "2YELRED",
      YEL: "GELB",
      RED: "ROT",
      T: "U",
      "CR%": "CR%",
      RM: "RM",
      LB: "LB",
      K: "K",
      KM: "KM",
    },
    quickPicks: {
      moneyline: "Moneyline",
      spread: "Spread",
      total: "Gesamt",
    },
  },
};
